import { Text, Tooltip, VFlow } from 'bold-ui'
import { Cns, Cpf } from 'components/label'
import { css } from 'emotion'
import React, { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'
import { humanizeAge } from 'util/date/humanize-age'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'
import { getNomeCidadao, hasDataNascimentoAfterDataAtividade } from 'view/atividade-coletiva/utils-atividadeColetiva'

interface ParticipanteCidadaoInfoProps {
  participante: ParticipanteModel
  dataAtividade: LocalDate
}

export const ParticipanteCidadaoInfo = (props: ParticipanteCidadaoInfoProps) => {
  const { dataAtividade, participante } = props
  const cidadao = participante.cidadao ?? participante.cidadaoParticipante
  const cidadaoHasDataNascimentoAfterDataAtividade = hasDataNascimentoAfterDataAtividade(
    dataAtividade,
    cidadao.dataNascimento
  )
  const hintIdadeCidadao = cidadaoHasDataNascimentoAfterDataAtividade
    ? 'A data de nascimento do cidadão foi atualizada e é posterior à data desta atividade'
    : 'Idade no dia desta atividade'

  return (
    <VFlow vSpacing={0.1} style={styles.container}>
      <Text fontWeight='bold'>{getNomeCidadao(cidadao)?.titleCase()}</Text>
      {(cidadao?.cpf && <Cpf value={cidadao.cpf} />) || (cidadao?.cns && <Cns value={cidadao.cns} />)}
      <Text>
        {cidadao.dataNascimento && (
          <Fragment>
            <Tooltip text={dataAtividade && hintIdadeCidadao} placement='bottom-start'>
              {cidadaoHasDataNascimentoAfterDataAtividade ? (
                <Text color='danger'>{formatDate(cidadao.dataNascimento)}</Text>
              ) : (
                <Text>{humanizeAge(cidadao.dataNascimento, dataAtividade)}</Text>
              )}
            </Tooltip>
            {` | `}
          </Fragment>
        )}
        {`${cidadao.sexo?.capitalize() ?? '-'}`}
      </Text>
    </VFlow>
  )
}

const styles = {
  container: css`
    margin: 1rem 0;
  `,
}
